export default __webpack_public_path__ + "static/media/bg3_m.bc47fcd7.png";